import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Breadcrumb, Dropdown } from "antd";
import TitlePage from "./TitlePage";
import { useMemo } from "react";
import { MenuProps } from "antd/lib";
import { useClient } from "hooks/useClient";
import { generateUserLogoutEvent } from "api/generated";
import { logOut } from "security";
import { MenuItem } from "../menu/menuTypes";
import { findMenuItemByPath } from "./menu/menuUtils";
import { useDistributionPoints } from "hooks/distributionPoints/useDistributionPoints";

interface HeaderBarProps {
  pathname: string;
  userRole: string;
  userEmail: string;
  menu: MenuItem[];
}

function HeaderBar({ pathname, userRole, userEmail, menu }: HeaderBarProps) {
  const { client } = useClient();
  const { distributionPoint } = useDistributionPoints();

  function onLogout() {
    generateUserLogoutEvent({ client }).finally(() => {
      logOut();
    });
  }

  const userProfile = useMemo(() => {
    switch (userRole) {
      case "ADMINISTRATOR":
        return "Administrador";
      case "SUPERVISOR":
        return "Supervisor";
      case "OPERATOR":
        return "Operador";
      default:
        return "Auditor fiscal";
    }
  }, [userRole]);

  const userDropdown: MenuProps["items"] = useMemo(() => {
    return [
      {
        key: "profile",
        label: (
          <span
            style={{
              cursor: "default",
            }}
          >
            {userProfile}
          </span>
        ),
      },
      {
        key: "email",
        label: (
          <span
            style={{
              cursor: "default",
            }}
          >
            {userEmail}
          </span>
        ),
      },
      {
        type: "divider",
      },
      {
        key: "logout",
        label: "Cerrar sesión",
        onClick: () => {
          onLogout();
        },
      },
    ];
  }, [userProfile, userEmail, onLogout]);

  const breadcrumItems = useMemo(() => {
    const menuItem = findMenuItemByPath(menu, pathname);
    const distributionName =
      !pathname.includes("new") &&
      distributionPoint &&
      menuItem?.section === "Instalación"
        ? {
            title: distributionPoint.name,
            href: undefined,
          }
        : undefined;
    const baseItems = [
      {
        href: "/cv",
        title: <HomeOutlined />,
      },
      {
        title: menuItem?.title,
        href: menuItem ? `/cv${menuItem.path}` : undefined,
      },
    ];

    if (distributionName) {
      baseItems.splice(1, 0, distributionName);
    }
    return baseItems;
  }, [menu, pathname, distributionPoint]);

  return (
    <div className="header-title">
      <Breadcrumb items={breadcrumItems} />
      <TitlePage pathname={pathname} menu={menu} />
      <Dropdown
        menu={{ items: userDropdown }}
        trigger={["click"]}
        placement="bottomRight"
        className="settingSession"
      >
        <Avatar icon={<UserOutlined />} />
      </Dropdown>
    </div>
  );
}

export default HeaderBar;
